const endpoint = 'https://api.ipstack.com/check';
const cache = new Map();
const inflight = new Map();
const globalKey = getGlobalKey();

/**
 * Fetch visitor location from IPStack.
 * Responses are cached per API key to avoid duplicate network calls.
 *
 * @param {string} apiKey
 * @return {Promise<{state: string|null, zip: string|null}>}
 */
export function getLocation(apiKey = null) {
	const key = apiKey || globalKey;
	if (!key) {
		return Promise.reject(new Error('Missing IPStack API key.'));
	}

	if (cache.has(key)) {
		return Promise.resolve(cache.get(key));
	}

	if (inflight.has(key)) {
		return inflight.get(key);
	}

	const request = fetch(buildUrl(key))
		.then(response => {
			if (!response.ok) {
				throw new Error(`IPStack request failed with ${response.status}`);
			}
			return response.json();
		})
		.then(data => {
			if (data && data.success === false) {
				const message = data.error && data.error.info ? data.error.info : 'Unknown IPStack error';
				throw new Error(message);
			}

			const location = {
				state: data && data.region_name ? data.region_name : null,
				zip: data && data.zip ? data.zip : null,
			};

			console.info('[IPStack] Resolved location', location);

			cache.set(key, location);
			inflight.delete(key);

			return location;
			})
			.catch(error => {
				inflight.delete(key);
				throw error;
			});

	inflight.set(key, request);

	return request;
}

function buildUrl(apiKey) {
	const url = new URL(endpoint);
	url.searchParams.set('access_key', apiKey);
	url.searchParams.set('fields', 'region_name,zip');
	return url.toString();
}

export default {
	getLocation,
};

function getGlobalKey() {
	if (typeof window === 'undefined') {
		return null;
	}

	const encoded = window?.fritzScripts?.ipstackKey || '';
	if (!encoded) return null;

	try {
		return atob(encoded);
	} catch (err) {
		return null;
	}
}
